import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, Select } from 'antd';
import FormError from '~/components/FormError';
import styles from '~/components/ResourceList/ResourceList.module.less';
import { usStateList } from '~/utils/formItems';
import MaskedInput from '~/components/MaskedInput';
import { validateZipCode } from '~/utils/formValidators';
import { formatZipCode } from '~/utils/utils';

const FormItem = Form.Item;
const { Option } = Select;

export class OrganizationForm extends PureComponent {
  static propTypes = {
    selectedOrganization: PropTypes.object,
    onUpdateOrganization: PropTypes.func,
    onCreateOrganization: PropTypes.func,
    form: PropTypes.object.isRequired,
    type: PropTypes.oneOf(['edit', 'new']).isRequired,
    submitting: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    formErrors: PropTypes.array.isRequired,
  }

  static defaultProps = {
    submitting: false,
    selectedOrganization: {},
    onUpdateOrganization: null,
    onCreateOrganization: null,
  }


  componentDidUpdate(prevProps) {
    const { onCancel, submitting, formErrors } = this.props;
    const hasSubmitted = prevProps.submitting && !submitting;
    const hasErrors = formErrors.length > 0;
    if (hasSubmitted && !hasErrors) {
      onCancel();
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { onCreateOrganization, onUpdateOrganization, form, type } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (type === 'new') {
          onCreateOrganization(values);
        } else if (type === 'edit') {
          const { selectedOrganization: { id } } = this.props;
          onUpdateOrganization(id, values);
        }
      }
    });
  };

  renderFormItems = () => {
    const { getFieldDecorator } = this.props.form;
    const { selectedOrganization } = this.props;

    const formItems = [
      {
        label: 'Name',
        fieldName: 'name',
        fieldOptions: {
          rules: [
            {
              required: true,
              message: 'Please enter a name',
            },
            {
              min: 3,
              message: 'Please enter a minimum of 3 characters',
            },
            {
              max: 25,
              message: 'Please only enter a maximum of 25 characters',
            },
          ],
        },
        component: <Input placeholder="eg. Bob" />,
      },
      {
        label: 'Account',
        fieldName: 'account',
        fieldOptions: {
          initialValue: selectedOrganization.account.name,
        },
        component: <Input disabled />,
      },
      {
        label: 'Address',
        fieldName: 'address',
        fieldOptions: {
          rules: [
            {
              required: true,
              message: 'Please enter the address',
            },
          ],
        },
        component: <Input autoComplete="_" placeholder="eg. 123 E 5th St" />,
      },
      {
        label: 'Subdomain',
        fieldName: 'subdomain',
        fieldOptions: {
          rules: [
            {
              required: true,
              message: 'Please enter a subdomain',
            },
            {
              min: 3,
              message: 'Please enter a minimum of 3 characters',
            },
            {
              max: 25,
              message: 'Please only enter a maximum of 25 characters',
            },
          ],
        },
        component: <Input className={styles.maxWidth} placeholder="keethealth" />,
      },
      {
        label: 'City',
        fieldName: 'address_city',
        fieldOptions: {},
        component: <Input autoComplete="_" placeholder="Austin" />,
      },
      {
        label: 'State',
        fieldName: 'address_state',
        fieldOptions: {},
        component: <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => option.props.children.includes(input.toUpperCase())}
          placeholder="Select a State"
        >
          {usStateList.map(state => <Option key={state}>{state}</Option>)}
        </Select>,
      },
      {
        label: 'Zip Code',
        fieldName: 'address_postalcode',
        fieldOptions: {
          rules: [
            { validator: validateZipCode },
          ],
          normalize: formatZipCode,
        },
        component: <MaskedInput mask="99999-9999" placeholder="12345-5678" autoComplete="_" />,
      },
    ];

    return formItems.map(({ label, fieldName, fieldOptions, component }) => (
      <FormItem label={label} key={fieldName}>
        {getFieldDecorator(fieldName, fieldOptions)(component)}
      </FormItem>
    ));
  }

  render() {
    const { submitting } = this.props;

    return (
      <Form onSubmit={this.handleSubmit} layout="vertical">
        <FormError />
        {this.renderFormItems()}
        <FormItem className="drawer-footer">
          <Button onClick={this.handleSubmit} type="primary" loading={submitting}>
            Save
          </Button>
          <Button className={styles.buttonStyles} onClick={this.props.onCancel}>
            Cancel
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default OrganizationForm;
